import { useState, useEffect, useCallback } from "react";
import { useAuth } from "react-oidc-context";
import { useNavigate } from "react-router-dom";
import { FiPlus } from "react-icons/fi";
import SitesTable from "../components/SitesTable";
import ErrorNotification from "../components/ErrorNotification";
import { fetchSites } from "../utils/api";
import {
  PageHeader,
  PageTitle,
  PageSubtitle,
  Button,
} from "../components/ui";

function Sites() {
  const auth = useAuth();
  const navigate = useNavigate();
  const [sites, setSites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState(null);

  const loadSites = useCallback(async () => {
    setLoading(true);
    try {
      const data = await fetchSites(auth.user?.id_token);
      const list = Array.isArray(data) ? data : [];
      list.sort((a, b) => new Date(b.date_added) - new Date(a.date_added));
      setSites(list);
    } catch (error) {
      setErrorMessage("Failed to load sites: " + error.message);
    } finally {
      setLoading(false);
    }
  }, [auth.user?.id_token]);

  useEffect(() => {
    loadSites();
  }, [loadSites]);

  return (
    <>
      <PageHeader>
        <div>
          <PageTitle>Sites</PageTitle>
          <PageSubtitle>Manage every parking site across the Carparky network.</PageSubtitle>
        </div>
        <Button onClick={() => navigate("/sites/add")}>
          <FiPlus /> Add site
        </Button>
      </PageHeader>

      <SitesTable
        sites={sites}
        loading={loading}
        onSiteUpdated={loadSites}
      />

      {errorMessage && (
        <ErrorNotification
          message={errorMessage}
          duration={4000}
          onClose={() => setErrorMessage(null)}
        />
      )}
    </>
  );
}

export default Sites;
